class HHProductTryOn extends HTMLElement {
  constructor() {
    super()
    this.eventsToRemove = []
  }

  connectedCallback() {
    this.wristSizeToggles = this.querySelectorAll('[data-wrist-size-toggle]')
    this.wristSizeToggles.forEach(inputToggle => {
      this.addTrackedEvent(
        inputToggle,
        'change',
        () => this.adjustWristSize(inputToggle)
      )
    })

    this.tabToggles = this.querySelectorAll('[data-tab-toggle]')
    this.tabsHolder = this.querySelector('[data-tabs-holder]')
    this.tabs = [...this.querySelectorAll('[data-tab]')]

    this.activeTab = this.tabs.find(tab =>
      tab.classList.contains('active')
    ) ?? null


    this.tabToggles.forEach(toggle => {
      this.addTrackedEvent(
        toggle,
        'change',
        () => this.updateTabs(toggle.value)
      )
    })

    this.adjustTabHolderSize()
    this.boundAdjustTabHolderSize = this.adjustTabHolderSize.bind(this);
    this.addTrackedEvent(
      window,
      'resize',
      this.boundAdjustTabHolderSize
    )
  }

  disconnectedCallback() {
    this.eventsToRemove.forEach(({ element, event, handler }) => {
      element.removeEventListener(event, handler)
    })
  }

  addTrackedEvent(element, event, handler) {
    element.addEventListener(event, handler)
    this.eventsToRemove.push({
      element,
      event,
      handler
    })
  }

  adjustWristSize(inputToggle) {
    if (!inputToggle || !inputToggle.checked) { return }

    const inputValue = Number(inputToggle.value ?? 1)
    const adjustmentSize = isNaN(inputValue)
      ? 0
      : Number(inputValue)

    this.style.setProperty('--wrist-scale', adjustmentSize)

    this.wristSizeToggles.forEach(toggle => {
      toggle.checked = toggle.value === inputToggle.value
    })
  }

  updateTabs(value = null) {
    const nextTab = this.tabs.find(tab =>
      tab.dataset.tab === value
    ) ?? null

    if (!nextTab) { return }

    this.activeTab?.classList.remove('active')
    nextTab.classList.add('active')
    this.activeTab = nextTab


    this.adjustTabHolderSize()
  }

  adjustTabHolderSize() {
    if (!this.tabsHolder || !this.activeTab) { return }

    this.tabsHolder.style.height = `${this.activeTab.scrollHeight}px`
  }


}

customElements.define('hh-product-try-on', HHProductTryOn)
